import React from 'react';
import './typing.scss';

export const Typing: React.FC = () => {
  const a = 0;

  return (
    <div className="typing">
      <div className="typing__dot" />
      <div className="typing__dot" />
      <div className="typing__dot" />
    </div>
  );
};
